module.exports = __webpack_public_path__ + "static/media/health-management_p2_1.4a3816ae.png";